<template>
  <div class="page-home">
    <TopNavbar title="分类"></TopNavbar>
    <div v-for="item in pageItemList" :key="item.id">
      <div v-if="item.unit_type === 2">
        <BannerList :bannerList="item.item" v-if="item.item && item.item.length > 0"></BannerList>
      </div>
      <div v-else-if="item.unit_type === 4" class="tag-item-container">
        <div v-for="tagItem in item.item" :key="tagItem.id"
             :class='["tag-item", tagItem.list_type === selectedListType?"selected-item":""]'
             @click="onSelect(tagItem)">
          {{tagItem.name}}
        </div>
      </div>
    </div>
    <MixItemFeed :listType="selectedListType" v-if="selectedListType"></MixItemFeed>
  </div>
</template>

<script>

  import BannerList from "../../common/BannerList";
  import {Toast} from "vant"
  import MixItemFeed from "../../ugc_item/MixItemFeed";
  import TopNavbar from "../../common/TopNavbar";

  export default {
    name: "Category",
    components: {TopNavbar, MixItemFeed, BannerList},
    data() {
      return {
        isLoading: false,

        pageItemList: [],
        selectedListType: "",
      }
    },
    mounted() {
      let listType = this.$route.query.list_type
      if (listType) {
        this.selectedListType = listType
      }
      this.initFrontPage()
    },
    methods: {

      async initFrontPage() {
        this.isLoading = true
        let params = {}
        if (this.$route.query.utm_source) {
          params.utm_source = this.$route.query.utm_source
        }
        await this.$store.dispatch("FeedCategoryPage", params).then((data) => {
          if (data.code === 0) {
            this.pageItemList = data.data
            this.setDefaultSelectedListType(this.pageItemList)
          }
        }, () => {
        })
        this.isLoading = false
      },

      setDefaultSelectedListType(itemList) {
        if (this.selectedListType) {
          return
        }
        for (let i = 0; i < itemList.length; i++) {
          let item = itemList[i]
          if (item.unit_type === 4) {
            if (item.item && item.item.length > 0) {
              this.selectedListType = item.item[0].list_type
            }
          }
        }
      },

      createToast(text, type) {
        Toast({
          message: text,
          duration: 1500,
        })
      },

      onSelect(item) {
        this.selectedListType = item.list_type
        console.log(item)
      }
    }

  }

</script>

<style lang="scss" scoped>
  .page-home {
    padding: 64px 15px 60px;
  }


  .tag-item-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: #333;
    border-bottom: 1px solid #fafafa;

    .tag-item {
      font-size: 14px;
      padding: 5px 8px;
      margin: 6px 5px;
      border: 1px solid transparent;
    }

    .selected-item {
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      border: 1px solid #fc9153;
      color: #fc9153;
    }
  }



</style>
